import styled, { css } from 'styled-components';
import { Row as AntdRow } from 'antd';
import savingsClubBg from 'v3/assets/images/flow-template-bg.png';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    // background-color: ${theme.colors.neutralSilver5};
    // background-image: url(${savingsClubBg});
    // background-repeat: no-repeat;
    // background-position: 100% 450px;
    // background-attachment: fixed;
    // background-size: 460px;

    padding: 80px 24px;
    position: relative;

    @media (max-width: 992px) {
      background-image: none;
      /* First section under <main>: no inset on mobile, so the card below runs edge
         to edge and the screen width goes to content rather than gutters. */
      padding: 0;
      margin: 0;
    }
  `}
`;

export const Container = styled.div`
  max-width: 1320px;
  margin: 0 auto;
`;

export const Row = styled(AntdRow)``;
